import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PageInfo } from '../../models';
import { BreadcrumbService, CoreService } from '../../services';
import { Router } from '@angular/router';

// tslint:disable-next-line: component-selector
@Component({ selector: 'boadmin-base', template: '' })

export class BoAdminBaseComponent implements OnInit, OnDestroy {

  protected result: Subscription;

  constructor(
    //protected indParam: CoreService,
    //protected bcrumb: BreadcrumbService,
    //protected router: Router
  ) { }

  ngOnInit(): void {
    // Initialize the directive/component after Angular first displays the data-bound properties and sets the directive/component's input properties.
  }

  ngOnDestroy(): void {
    // Cleanup just before Angular destroys the directive/component.
    // Unsubscribe Observables and detach event handlers to avoid memory leaks.
    // Called just before Angular destroys the directive / component.
    if (this.result) {
      this.result.unsubscribe();
    }
  }

  //openViewInBreadcrumb(link: string, title: string, params: string = ''): void {
  //  this.bcrumb.itemAdd3(link, title, true, params);
  //  const dest: string = params !== '' ? `${link}?${params}` : link;
  //  this.openView(dest);
  //}

  //openView(routePath: string): void {
  //  this.indParam.showSplash(this.indParam.CurrentUrl.FullUrl !== routePath);
  //  this.indParam.CurrentUrl = new PageInfo(routePath);
  //  this.router.navigate([this.indParam.CurrentUrl.Url]);
  //}
}
